import { useCallback } from "react"
import { useSetState } from "ahooks-v2"
import { createModel } from "hox"
import type { SceneList, CompanySceneList, BusinessSceneList, RuralSceneListVO } from "@/api"
// ==============================================
interface ProfileArgs {
  // 企业-点击名称触发
  activeCompanyShop?: CompanySceneList
  // 企业-点击状态触发
  companyShopService?: CompanySceneList
  // 企业-数据更新凭据
  companyRefreshCount: number
  // 商户-点击名称触发
  activeBusinessShop?: BusinessSceneList
  // 商户-点击状态触发
  businessShopService?: BusinessSceneList
  // 商户-数据更新凭据
  businessRefreshCount: number
  // 小区-点击名称触发
  activeEstateShop?: SceneList
  // 农村-点击名称触发
  activeRuralShop?: RuralSceneListVO
  // 农村-列表
  ruralList: RuralSceneListVO[]
}
function useProfile() {
  const [state, set] = useSetState<ProfileArgs>({
    companyRefreshCount: 0,
    businessRefreshCount: 0,
    ruralList: [],
  })

  const setAllState = useCallback(
    (value: Partial<ProfileArgs> | ((prevState: ProfileArgs) => Partial<ProfileArgs>)) => {
      set(value)
    },
    [set],
  )

  return {
    ...state,
    setAllState,
  }
}

export default createModel(useProfile)
